module.exports = __webpack_public_path__ + "img/icon_search.02f3093.png";